var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6164 6.14609L14.6155 6.14488L11.4227 1.39824C11.4227 1.39819 11.4226 1.39815 11.4226 1.3981C11.4178 1.391 11.4113 1.38518 11.4037 1.38116C11.3961 1.3771 11.3876 1.37499 11.3789 1.375L11.3783 1.375L4.62165 1.375C4.61311 1.37505 4.60472 1.37718 4.59718 1.38119C4.58961 1.38523 4.58314 1.39105 4.57833 1.39815L14.6164 6.14609ZM14.6164 6.14609C14.6219 6.15426 14.6249 6.16385 14.6251 6.1737V14.4553L14.6244 14.4566L14.6242 14.5742C14.6242 14.5879 14.6188 14.6011 14.6091 14.6108C14.5994 14.6204 14.5863 14.6259 14.5727 14.626C14.5726 14.626 14.5726 14.626 14.5725 14.626L10.9832 14.626C10.9535 14.626 10.9322 14.6034 10.9322 14.5758V7.58164V7.4178L10.8352 7.28573L9.61528 5.62414L9.46544 5.42005H9.21224H6.787H6.53381L6.38397 5.62414L5.16403 7.28573L5.06707 7.4178V7.58164V14.575C5.06707 14.6026 5.04572 14.6251 5.01607 14.6251H1.42599C1.39635 14.6251 1.375 14.6026 1.375 14.575V6.17189C1.37504 6.16263 1.37783 6.15359 1.38302 6.14592L1.38365 6.14498L4.57827 1.39824L14.6164 6.14609Z",
    fill: "#C2C2C2",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandong);
export default __webpack_public_path__ + "static/media/handong.1926a777bc31428e33e2f0a73f6fa285.svg";
export { ForwardRef as ReactComponent };